import { noop } from 'lodash';
import { createContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

/**
 * Shared state for the "SmartReview" step. The wizard owns whether SmartReview
 * is enabled (default on) so the step's Body can render/toggle it and the
 * wizard's completion action can read it; the Body and Footer render into
 * separate DOM regions, so a context is the clean way to share it.
 */
export interface SmartReviewStepContextValue {
  isSmartReviewEnabled: boolean;
  setIsSmartReviewEnabled: (enabled: boolean) => void;
}

export const SmartReviewStepContext =
  createContext<SmartReviewStepContextValue>({
    isSmartReviewEnabled: true,
    setIsSmartReviewEnabled: noop,
  });

export const useSmartReviewStepContext = () =>
  useGuardedContext(SmartReviewStepContext, 'SmartReviewOnboardingModal');
